import React, { Component } from 'react';
import { Row, Checkbox, Form, Button, Divider } from 'antd';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';

import styles from './BulkMCRateUpdateBody.module.css';
import FormDatePickerRange from 'components/FormDatePickerRange/FormDatePickerRange';

import BulkMCRateUpdate from '../BulkMCRateUpdate/BulkMCRateUpdate';
import intl from 'react-intl-universal';

const formatMomentDateOnly = date => {
  return moment(date).startOf('day');
};

const todayDate = formatMomentDateOnly();

class BulkMCRateUpdateBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRoomTypes: [],
      selectedUnits: [],
      allUnits: [],
      dynamicFormItems: [
        {
          dateRange0: [formatMomentDateOnly(), formatMomentDateOnly()]
        }
      ] // Initialize with one empty object
    };
  }

  componentDidMount() {
    const { defaultRoomType, defaultUnit, roomTypesWithRatesAndUnits, form } = this.props;

    const newStateToSet = {};
    const newFormValue = {};

    if (!defaultRoomType && !defaultUnit) {
      // To prevent unnecessary set state
      return;
    }

    if (defaultRoomType) {
      const foundDefaultRoomType = roomTypesWithRatesAndUnits.find(roomTypeWithRatesAndUnits => {
        return roomTypeWithRatesAndUnits.id === defaultRoomType;
      });
      newStateToSet.selectedRoomTypes = [foundDefaultRoomType];
      newFormValue.roomTypesApplied = [foundDefaultRoomType.id];
      newStateToSet.allUnits = foundDefaultRoomType.units;
    }

    if (defaultUnit) {
      if (newStateToSet.allUnits) {
        const newSelectedUnit = newStateToSet.allUnits.find(unit => {
          return unit.id === defaultUnit;
        });
        newStateToSet.selectedUnits = [newSelectedUnit];
        newFormValue.unitsApplied = [newSelectedUnit.id];
      }
    }

    this.setState(newStateToSet);
    form.setFieldsValue(newFormValue);
  }

  componentDidUpdate(prevProps) {
    const prevApplyId = prevProps.applyBookmarkRequest ? prevProps.applyBookmarkRequest.applyId : null;
    const nextApplyId = this.props.applyBookmarkRequest ? this.props.applyBookmarkRequest.applyId : null;

    if (nextApplyId && prevApplyId !== nextApplyId) {
      this.applyBookmarkToAllDynamicItems(this.props.applyBookmarkRequest);
    }
  }

  applyBookmarkToAllDynamicItems = applyBookmarkRequest => {
    const { form, roomTypesWithRatesAndUnits } = this.props;
    const { dynamicFormItems } = this.state;
    if (!applyBookmarkRequest) {
      return;
    }

    const bookmarkSelections =
      Array.isArray(applyBookmarkRequest.selections) && applyBookmarkRequest.selections.length > 0
        ? applyBookmarkRequest.selections
        : [{ roomTypeIds: applyBookmarkRequest.roomTypeIds || [], unitIds: applyBookmarkRequest.unitIds || [] }];
    const stateToSet = {};
    const formValuesToSet = {};
    const targetCount = Math.max(bookmarkSelections.length, 1);

    const updatedDynamicFormItems =
      dynamicFormItems.length >= targetCount
        ? dynamicFormItems.slice(0, targetCount)
        : [...dynamicFormItems, ...Array.from({ length: targetCount - dynamicFormItems.length }, () => dynamicFormItems[0])];

    updatedDynamicFormItems.forEach((item, index) => {
      const selection = bookmarkSelections[index] || { roomTypeIds: [], unitIds: [] };
      const selectedRoomTypes = roomTypesWithRatesAndUnits.filter(roomType => selection.roomTypeIds.includes(roomType.id));
      const allUnits = selectedRoomTypes.flatMap(roomType => roomType.units || []);
      const selectedUnits = allUnits.filter(unit => selection.unitIds.includes(unit.id));
      const roomTypeIds = selectedRoomTypes.map(roomType => roomType.id);
      const unitIds = selectedUnits.map(unit => unit.id);

      stateToSet['selectedRoomTypes' + index] = selectedRoomTypes;
      stateToSet['allUnits' + index] = allUnits;
      stateToSet['selectedUnits' + index] = selectedUnits;
      formValuesToSet['roomTypesApplied' + index] = roomTypeIds;
      formValuesToSet['unitsApplied' + index] = unitIds;
    });

    this.setState(
      {
        ...stateToSet,
        dynamicFormItems: updatedDynamicFormItems
      },
      () => {
        // Ensure newly added dynamic form items are mounted before setting values.
        if (dynamicFormItems.length > targetCount) {
          const fieldsToReset = [];
          for (let i = targetCount; i < dynamicFormItems.length; i++) {
            fieldsToReset.push(`dateRange${i}`, `selectedDays${i}`, `roomTypesApplied${i}`, `unitsApplied${i}`, `roomTypesRate${i}`, `unitsRate${i}`);
          }
          form.resetFields(fieldsToReset);
        }
        form.setFieldsValue(formValuesToSet);
      }
    );
  };

  handleOnRoomTypeChange = (newRoomTypeIds, index) => {
    const { form, roomTypesWithRatesAndUnits } = this.props;
    const { selectedUnits, selectedRoomTypes } = this.state;

    const isAddNewRoomType = newRoomTypeIds.length > selectedRoomTypes.length;
    const allUnits = [];
    const selectedRoomTypeIds = [];

    const getNewSelectedRoomTypes = () => {
      return newRoomTypeIds.map(newRoomTypeId => {
        const selectedRoomType = roomTypesWithRatesAndUnits.find(roomType => {
          return roomType.id === newRoomTypeId;
        });
        allUnits.push(...selectedRoomType.units);
        selectedRoomTypeIds.push(selectedRoomType.id);
        return selectedRoomType;
      });
    };

    const newSelectedRoomTypes = getNewSelectedRoomTypes();

    // const getNewSelectedUnits = () => {
    //   const filteredSelectedUnits = selectedUnits.filter(unit => {
    //     return selectedRoomTypeIds.includes(unit.roomType);
    //   });
    //   if (isAddNewRoomType) {
    //     const newlyAddedRoomType = newSelectedRoomTypes[newRoomTypeIds.length - 1];
    //     if (newlyAddedRoomType.units.length === 1) {
    //       return [...filteredSelectedUnits, ...newlyAddedRoomType.units];
    //     }
    //   }
    //   return filteredSelectedUnits;
    // };

    // const filteredUnits = getNewSelectedUnits();

    console.log('newSelectedRoomTypes', newSelectedRoomTypes);

    console.log('allUnits', allUnits);
    // console.log('selectedUnits', selectedUnits);

    const getFormUnitsApplied = form.getFieldValue('unitsApplied' + index);

    console.log('getFormUnitsApplied', getFormUnitsApplied);

    const filteredUnits = getFormUnitsApplied.filter(unitId => {
      return allUnits.some(allUnit => allUnit.id === unitId);
    });

    console.log('filteredUnits', filteredUnits);

    this.setState({
      // selectedRoomTypes: newSelectedRoomTypes,
      ['allUnits' + index]: allUnits,
      ['selectedRoomTypes' + index]: newSelectedRoomTypes,
      ['selectedUnits' + index]: filteredUnits.map(unitId => {
        return allUnits.find(unit => {
          return unit.id === unitId;
        });
      })
    });

    if (allUnits.length === 0) {
      this.setState({
        ['selectedUnits' + index]: []
      });
    }

    console.log(this.state, 168);

    form.setFieldsValue({
      ['unitsApplied' + index]: filteredUnits.map(unitId => {
        return unitId;
      })
    });

    // form.setFieldsValue({
    //   unitsApplied: filteredUnits.map(unit => {
    //     return unit.id;
    //   })
    // });
  };

  handleOnUnitChange = (newUnitIds, index) => {
    console.log('newUnitIds', newUnitIds);

    const { allUnits, form } = this.state;

    const selectedUnits = newUnitIds.map(newUnitId => {
      return this.state['allUnits' + index].find(unit => {
        return unit.id === newUnitId;
      });
    });

    console.log('selectedUnits', selectedUnits);

    // const selectedUnits = newUnitIds.map(newUnitId => {
    //   return allUnits.find(unit => {
    //     return unit.id === newUnitId;
    //   });
    // });
    this.setState({
      ['selectedUnits' + index]: selectedUnits
    });
  };

  selectAllRoomTypes = index => {
    const { form, roomTypesWithRatesAndUnits } = this.props;
    const allUnits = roomTypesWithRatesAndUnits.flatMap(roomType => roomType.units);

    this.setState({
      ['allUnits' + index]: allUnits,
      ['selectedRoomTypes' + index]: roomTypesWithRatesAndUnits,
      ['selectedUnits' + index]: []
    });

    form.setFieldsValue({
      ['roomTypesApplied' + index]: roomTypesWithRatesAndUnits.map(roomType => roomType.id),
      ['unitsApplied' + index]: []
    });
  };

  clearAllRoomTypes = index => {
    const { form } = this.props;
    form.setFieldsValue({ ['roomTypesApplied' + index]: [], ['unitsApplied' + index]: [] });
    this.setState({ ['selectedRoomTypes' + index]: [], ['selectedUnits' + index]: [], ['allUnits' + index]: [] });
  };

  selectAllUnits = index => {
    const { form } = this.props;
    const allUnits = this.state['allUnits' + index] || [];
    this.setState({
      ['selectedUnits' + index]: allUnits
    });
    form.setFieldsValue({
      ['unitsApplied' + index]: allUnits.map(unit => unit.id)
    });
  };

  clearAllUnits = index => {
    const { form } = this.props;
    form.setFieldsValue({ ['unitsApplied' + index]: [] });
    this.setState({ ['selectedUnits' + index]: [] });
  };

  addDynamicFormItem = () => {
    this.setState(prevState => ({
      dynamicFormItems: [...prevState.dynamicFormItems, this.state.dynamicFormItems[0]]
    }));
  };

  removeDynamicFormItem = index => {
    const { form } = this.props;
    const { dynamicFormItems } = this.state;

    for (let i = index; i < dynamicFormItems.length - 1; i++) {
      this.state['allUnits' + i] = this.state['allUnits' + (i + 1)];
      this.state['selectedRoomTypes' + i] = this.state['selectedRoomTypes' + (i + 1)];
      this.state['selectedUnits' + i] = this.state['selectedUnits' + (i + 1)];
    }

    delete this.state['allUnits' + (dynamicFormItems.length - 1)];
    delete this.state['selectedRoomTypes' + (dynamicFormItems.length - 1)];
    delete this.state['selectedUnits' + (dynamicFormItems.length - 1)];

    for (let i = index; i < dynamicFormItems.length - 1; i++) {
      form.setFieldsValue({
        [`dateRange${i}`]: form.getFieldValue(`dateRange${i + 1}`),
        [`selectedDays${i}`]: form.getFieldValue(`selectedDays${i + 1}`),
        [`roomTypesApplied${i}`]: form.getFieldValue(`roomTypesApplied${i + 1}`),
        [`unitsApplied${i}`]: form.getFieldValue(`unitsApplied${i + 1}`),
        [`roomTypesRate${i}`]: form.getFieldValue(`roomTypesRate${i + 1}`),
        [`unitsRate${i}`]: form.getFieldValue(`unitsRate${i + 1}`)
      });
    }

    form.resetFields([
      `dateRange${dynamicFormItems.length - 1}`,
      `selectedDays${dynamicFormItems.length - 1}`,
      `roomTypesApplied${dynamicFormItems.length - 1}`,
      `unitsApplied${dynamicFormItems.length - 1}`,
      `roomTypesRate${dynamicFormItems.length - 1}`,
      `unitsRate${dynamicFormItems.length - 1}`
    ]);

    let filterDynamicFormItems = this.state.dynamicFormItems.filter((data, localindex) => localindex !== index);

    // console.log('filterDynamicFormItems', filterDynamicFormItems);

    // console.log(form.getFieldsValue(), 186);

    // Remove the index in roomTypesRate and shift higher indexes down by one
    const i = index;
    const values = form.getFieldsValue();
    if (values.roomTypesRate) {
      const newRoomTypesRate = {};
      for (const key in values.roomTypesRate) {
        const match = key.match(/^([a-zA-Z]+)(\d+)$/);
        if (match) {
          const prefix = match[1];
          const idx = parseInt(match[2], 10);
          if (idx < i) {
            newRoomTypesRate[key] = values.roomTypesRate[key];
          } else if (idx > i) {
            newRoomTypesRate[`${prefix}${idx - 1}`] = values.roomTypesRate[key];
          }
        }
      }
      form.setFieldsValue({ roomTypesRate: newRoomTypesRate });
    }

    // Remove the index in unitsRate and shift higher indexes down by one
    if (values.unitsRate) {
      const newUnitsRate = {};
      for (const key in values.unitsRate) {
        const match = key.match(/^([a-zA-Z]+)(\d+)$/);
        if (match) {
          const prefix = match[1];
          const idx = parseInt(match[2], 10);
          if (idx < i) {
            newUnitsRate[key] = values.unitsRate[key];
          } else if (idx > i) {
            newUnitsRate[`${prefix}${idx - 1}`] = values.unitsRate[key];
          }
        }
      }
      form.setFieldsValue({ unitsRate: newUnitsRate });
    }

    this.setState({
      dynamicFormItems: filterDynamicFormItems
    });

    // console.log(this.state, 187);

    // this.setState(prevState => {
    //   console.log(prevState.dynamicFormItems, index, 187);
    //   let dynamicFormItems = [...prevState.dynamiFcormItems];
    //   dynamicFormItems = dynamicFormItems.filter((data, localindex) => localindex !== index);
    //   return { dynamicFormItems };
    // });
  };

  render() {
    const { allUnits, selectedUnits, selectedRoomTypes, dynamicFormItems } = this.state;
    const {
      form,
      daySelections,
      selectedDays,
      onSelectedDayChange,
      roomTypesWithRatesAndUnits,
      rateTypes,
      defaultStartDate,
      defaultEndDate
    } = this.props;

    const translatedDaySelections = daySelections.map(day => {
      const translatedLabel = intl.get(`hostConnect.integration.days.${day.label}`).d(day.label);
      return { ...day, label: translatedLabel };
    });

    // console.log(allUnits, 184);
    return (
      <>
        {dynamicFormItems.map((item, index) => (
          <div key={index}>
            <Row>
              <span style={{ color: 'red' }}>*</span> {intl.get('multicalendar.headerLabels.dateRange').d('Date Range')}
            </Row>
            <Row>
              <FormDatePickerRange
                form={form}
                disabledDate={currentDate => {
                  return (
                    todayDate.isAfter(currentDate) ||
                    moment(todayDate)
                      .add(730, 'days')
                      .isSameOrBefore(currentDate)
                  );
                }}
                // fieldName={'dateRange'}
                fieldName={'dateRange' + index}
                requiredErrorMessage={intl.get('multicalendar.placeholder.dateMsg').d('Please select a range of dates')}
                defaultPickerValue={[
                  defaultStartDate ? formatMomentDateOnly(defaultStartDate) : formatMomentDateOnly(),
                  defaultEndDate ? formatMomentDateOnly(defaultEndDate) : formatMomentDateOnly()
                ]}
              />
            </Row>
            <Row>{intl.get('multicalendar.headerLabels.dayOfWeek').d('Which days of the week do you want to apply the changes to?')}</Row>
            <Row className={styles.checkboxSelection}>
              <br />
              {form.getFieldDecorator('selectedDays' + index, {
                initialValue: selectedDays
              })(
                <Checkbox.Group
                  options={translatedDaySelections}
                  // onChange={onSelectedDayChange}
                />
              )}
            </Row>

            <Row>
              <BulkMCRateUpdate
                type="roomType"
                index={index}
                selectAllButtonId={`select-button1-rooms-ruw-${index}`}
                clearAllButtonId={`clear-button1-rooms-ruw-${index}`}
                disclaimer={
                  <span>
                    <p>
                      {intl
                        .getHTML('multicalendar.headerLabels.forSingle')
                        .d('<strong>For single selection:</strong> Room type with only one unit will be auto selected.')}
                    </p>
                    <p>
                      <i>
                        {intl.getHTML('multicalendar.headerLabels.selectAll').d('Note: Select all will <strong>NOT</strong> auto select any unit.')}
                      </i>
                    </p>
                  </span>
                }
                form={form}
                items={roomTypesWithRatesAndUnits}
                selectedItems={this.state['selectedRoomTypes' + index] ? this.state['selectedRoomTypes' + index] : []}
                rateTypes={rateTypes}
                onSelectionChange={this.handleOnRoomTypeChange}
                onSelectAll={() => this.selectAllRoomTypes(index)}
                onClearAll={() => this.clearAllRoomTypes(index)}
                currency={this.props.currency}
                timezone={this.props.timezone}
              />
            </Row>

            <BulkMCRateUpdate
              type="unit"
              index={index}
              selectAllButtonId={`select-button2-units-ruw-${index}`}
              clearAllButtonId={`clear-button2-units-ruw-${index}`}
              form={form}
              items={this.state['allUnits' + index] ? this.state['allUnits' + index] : []}
              selectedItems={this.state['selectedUnits' + index] ? this.state['selectedUnits' + index] : []}
              rateTypes={rateTypes}
              onSelectionChange={this.handleOnUnitChange}
              onSelectAll={() => this.selectAllUnits(index)}
              onClearAll={() => this.clearAllUnits(index)}
              currency={this.props.currency}
              timezone={this.props.timezone}
              selectedRoomTypes={this.state['selectedRoomTypes' + index] ? this.state['selectedRoomTypes' + index] : []}
            />

            {dynamicFormItems.length > 1 && (
              <>
                <Button
                  type="dashed"
                  style={{
                    marginTop: 24,
                    color: 'red',
                    borderColor: 'red'
                  }}
                  onClick={() => this.removeDynamicFormItem(index)}
                >
                  Remove Rate Update Wizard
                </Button>
              </>
            )}
            <Divider />
          </div>
        ))}

        <Row>
          <Button
            style={{
              color: dynamicFormItems.length >= 10 ? '#d9d9d9' : '#00b9c6',
              borderColor: dynamicFormItems.length >= 10 ? '#d9d9d9' : '#00b9c6'
            }}
            onClick={this.addDynamicFormItem}
            disabled={dynamicFormItems.length >= 10}
          >
            Add Rate Update Wizard
          </Button>
        </Row>
        <Row>
          <br />
        </Row>
      </>
    );
  }
}

BulkMCRateUpdateBody.propTypes = {
  form: PropTypes.object.isRequired,
  daySelections: PropTypes.array.isRequired,
  selectedDays: PropTypes.array.isRequired,
  onSelectedDayChange: PropTypes.func.isRequired,
  roomTypesWithRatesAndUnits: PropTypes.array.isRequired,
  rateTypes: PropTypes.array.isRequired,
  applyBookmarkRequest: PropTypes.object,
  defaultStartDate: PropTypes.string,
  defaultEndDate: PropTypes.string,
  defaultRoomType: PropTypes.string,
  defaultUnit: PropTypes.string,
  currency: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired
};

BulkMCRateUpdateBody.defaultProps = {
  form: {},
  daySelections: [],
  selectedDays: [],
  onSelectedDayChange: () => {},
  roomTypesWithRatesAndUnits: [],
  rateTypes: [],
  applyBookmarkRequest: null
};

export default withRouter(BulkMCRateUpdateBody);
